console.log('[APP] 1. Início do App.jsx');
console.log('[APP] 2. Importando BrowserRouter...');
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
console.log('[APP] 3. BrowserRouter importado');
console.log('[APP] 4. Importando ThemeProvider...');
import { ThemeProvider, createTheme } from '@mui/material/styles';
console.log('[APP] 5. ThemeProvider importado');
console.log('[APP] 6. Importando CssBaseline...');
import CssBaseline from '@mui/material/CssBaseline';
console.log('[APP] 7. CssBaseline importado');
console.log('[APP] 7.5. Importando React Query...');
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
console.log('[APP] 7.6. React Query importado');
console.log('[APP] 8. Importando componentes essenciais...');
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import OnboardingWelcome from './components/OnboardingWelcome';
import { OnboardingProvider } from './contexts/OnboardingContext';
import { ThemeCustomProvider } from './contexts/ThemeCustomContext';
import ThemeApplier from './components/ThemeApplier';
console.log('[APP] 8.5. Importando páginas...');

// Import direto das páginas (sem lazy loading)
import DashboardPage from './pages/DashboardPage';
import AppointmentsPage from './pages/AppointmentsPage';
import ServicesPage from './pages/ServicesPage';
import ProfessionalsPage from './pages/ProfessionalsPage';
import PlacesPage from './pages/PlacesPage';
import SchedulesPage from './pages/SchedulesPage';
import PaymentMethodsPage from './pages/PaymentMethodsPage';
import ScheduleBlocksPage from './pages/ScheduleBlocksPage';
import PersonsPage from './pages/PersonsPage';

console.log('[APP] 9. Páginas importadas');

console.log('[APP] 10. Criando tema...');
// Tema customizado com otimizações mobile
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    
    // Títulos principais - responsivos
    h4: {
      fontWeight: 600,
      fontSize: '2.125rem',  // 34px desktop
      '@media (max-width:600px)': {
        fontSize: '1.75rem',  // 28px mobile (-18%)
      },
    },
    
    h5: {
      fontWeight: 600,
      fontSize: '1.5rem',  // 24px desktop
      '@media (max-width:600px)': {
        fontSize: '1.375rem',  // 22px mobile (-8%)
      },
    },
    
    h6: {
      fontWeight: 600,
      fontSize: '1.25rem',  // 20px desktop
      '@media (max-width:600px)': {
        fontSize: '1.125rem',  // 18px mobile (-10%)
      },
    },
    
    // Corpo de texto
    body1: {
      fontSize: '1rem',  // 16px desktop
      '@media (max-width:600px)': {
        fontSize: '0.9375rem',  // 15px mobile (-6%)
      },
    },
    
    body2: {
      fontSize: '0.875rem',  // 14px desktop
      '@media (max-width:600px)': {
        fontSize: '0.8125rem',  // 13px mobile (-7%)
      },
    },
    
    // Botões
    button: {
      textTransform: 'none',
      fontSize: '0.875rem',
      '@media (max-width:600px)': {
        fontSize: '0.8125rem',
      },
    },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          '@media (max-width:600px)': {
            borderRadius: 6,
          },
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: 16,
          '@media (max-width:600px)': {
            padding: 12,  // -25% padding mobile
            '&:last-child': {
              paddingBottom: 12,
            },
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          '@media (max-width:600px)': {
            borderRadius: 6,
          },
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          paddingLeft: 24,
          paddingRight: 24,
          '@media (max-width:600px)': {
            paddingLeft: 16,
            paddingRight: 16,
          },
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          '@media (max-width:600px)': {
            fontSize: '0.875rem',
          },
        },
      },
    },
  },
});
console.log('[APP] 11. Tema criado:', theme);

// Configuração do React Query
console.log('[APP] 11.5. Criando QueryClient...');
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutos - dados considerados "frescos"
      cacheTime: 10 * 60 * 1000, // 10 minutos - tempo em cache
      refetchOnWindowFocus: false, // Não refetch ao focar janela
      retry: 1, // Tentar apenas 1 vez em caso de erro
    },
  },
});
console.log('[APP] 11.6. QueryClient criado');

console.log('[APP] 12. Definindo função App...');
function App() {
  console.log('[APP] 13. App() executando...');
  console.log('[APP] 14. Retornando JSX...');
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeCustomProvider>
        <ThemeApplier baseTheme={theme}>
          <CssBaseline />
          <OnboardingProvider>
            <BrowserRouter>
              <OnboardingWelcome />
              <Routes>
                <Route
                  path="/"
                  element={
                    <ProtectedRoute>
                      <Layout />
                    </ProtectedRoute>
                  }
                >
                  <Route index element={<Navigate to="/dashboard" replace />} />
                  <Route path="dashboard" element={<DashboardPage />} />
                  <Route path="appointments" element={<AppointmentsPage />} />
                  <Route path="professionals" element={<ProfessionalsPage />} />
                  <Route path="places" element={<PlacesPage />} />
                  <Route path="services" element={<ServicesPage />} />
                  <Route path="schedules" element={<SchedulesPage />} />
                  <Route path="persons" element={<PersonsPage />} />
                  <Route path="payment-methods" element={<PaymentMethodsPage />} />
                  <Route path="absences" element={<ScheduleBlocksPage />} />
                </Route>
              </Routes>
            </BrowserRouter>
          </OnboardingProvider>
        </ThemeApplier>
      </ThemeCustomProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

console.log('[APP] 15. Exportando App...');
export default App;
console.log('[APP] 16. App exportado com sucesso!');
